// Static Domain Data and Styles
// This file contains all domain data and styles fetched from database
// Update this file when domain data or styles change in the database

export const STATIC_DOMAIN_DATA = {
    // Domain ID 0 - Default (Bondi Classifieds)
    0: {
        id: 0,
        url: 'https://www.bondiclassifieds.com.au/',
        title: 'Bondi Classifieds',
        main_title: 'Bondi Classifieds',
        domain_img: 'bondinewBigFlag.png', // Will use default image
        styles: [] // No styles for default domain
    },
    // Domain ID 2 - Manly Classifieds
    2: {
        id: 2,
        url: 'www.manlyclassifieds.com.au',
        title: 'Manly Classifieds',
        main_title: 'Manly Classifieds',
        zip_range: '2084,2085,2086,2087,2092,2093,2094,2095,2096,2097,2099,2100,2101,2102,2103,2104,2105,2106,2107,2108',
        domain_img: 'manly-logo.png',
        map: 'mainlyaus_map.gif',
        dom_Onlineimg: '1000-dark-redman.png',
        dom_sidefreead: 'manlycfd-postyourad.png',
        manage_ad: 'mainly-manage_ads.gif',
        dom_sidelogin: 'mainly-member-login-button.gif',
        domore: 'domorecor.png',
        fblogin: 'fb-loginman.png',
        fblogout: 'fb-log-outmn.png',
        fb_app_id: '2067491126808156',
        fb_secret: 'a413b82828a00c72551d8a4152180af3',
        searchedlistimg: 'serch-4.png',
        fevadsimg: 'serch-3.png',
        showDomainads: 0,
        domain_meta_title: 'Manly and Northern Beaches free online classifieds',
        domain_meta_keywords: 'Northern Beaches, Manly Sydney, Manly, Manly beach, Manly Jobs, Manly Realestate, Manly restaurants, Manly tradies, Manly business services, Manly accommodation, manly beach, Manly roommate, manly flatmate, manly business, Manly shopping, Manly nightlife, Manly news, Manly free classifieds, Manly escorts, Manly Personals, Manly Brothels, Manly Erotic massage, northern beaches council news, Manly Sydney NSW',
        domain_meta_desc: 'Manly and Northern Beaches classifieds - 1000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell & Escort services ',
        fbsharetitle: 'Manly Classifieds',
        fbsharedescription: 'Free Classifieds for Manly Sydney Northern Beaches - 1000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more.',
        showlocalnews: 0,
        domain_webmaster: 'PKNbMqISk8kID8aQcKgvLB3D9d3IaA0a1gYK-2poxoE',
        is_deleted: 1,
        styles: [{
            id: 1,
            domain_id: 2,
            time_color: '008723',
            header_search_text: '000000',
            header_buttoncolor: '008723',
            header_menu: '008723',
            header_menu_hover: '9A0000',
            side_text: '008723',
            side_back: '008723',
            list_side_back: 'e6e9ec',
            leftside_link: '0d3b63',
            left_menu_hover: '9A0000',
            rightside_link: '008723',
            common_links: '9A0000',
            lat_title: '008723',
            lat_back: '',
            footer_cat_back: '5c956b',
            foot_back: '008723',
            free_title: '008723',
            featured_title: '008723',
            detail_titles: '008723'
        }]
    },
    // Domain ID 3 - Western Australia Classifieds
    3: {
        id: 3,
        url: 'www.WesternAustraliaClassifieds.com.au',
        title: 'Western Australia Classifieds',
        main_title: 'Western Australia Classifieds',
        zip_range: '6000,6001,6003,6004,6005,6006,6007,6008,6009,6010,6011,6012,6013,6014,6015,6017,6020,6210',
        domain_img: 'logowestern.png',
        map: 'caus_mapwestern.gif',
        dom_Onlineimg: '1000-maroon.png',
        dom_sidefreead: 'manlycfd-postyourad.png',
        manage_ad: 'qcmanageadswestern.gif',
        dom_sidelogin: 'member-login-buttonwestern.gif',
        domore: '',
        fblogin: 'fb-loginwestern.png',
        fblogout: 'fb-qclogoutwestern.png',
        fb_app_id: '1342375635888914',
        fb_secret: 'df60f49cf38d9dc830b8264d39aabe59',
        searchedlistimg: 'serch-4.png',
        fevadsimg: 'serch-3.png',
        showDomainads: 0,
        domain_meta_title: 'Western Australia  Online Classifieds',
        domain_meta_keywords: 'Perth Classifieds,Western Australia Jobs, Western Australia realestate, Western Australia restaurants, tradies,  Western Australia  accommodation, Western Australia beach,Western Australia  roommate, Western Australia flatmate, Western Australia business, Western Australia shopping, Western Australia nightlife, Western Australia news, Free classifieds',
        domain_meta_desc: 'Free online Classifieds for Perth Western Australia - 1000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell,  Escort services and more',
        fbsharetitle: 'Western Australia Free Online Classifieds',
        fbsharedescription: 'Free online Classifieds for Perth Western Australia - 1000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell,  Escort services and more',
        showlocalnews: 1,
        domain_webmaster: 'K_I-xne7MCBCUMRltamgUEOeGHLmD1XXm8wx_Je581E',
        is_deleted: 1,
        styles: [{
            id: 13,
            domain_id: 3,
            time_color: 'd40202',
            header_search_text: 'd40202',
            header_buttoncolor: 'd40202',
            header_menu: 'C10202',
            header_menu_hover: 'e70f0f',
            side_text: 'd40202',
            side_back: 'd40202',
            list_side_back: '',
            leftside_link: '',
            left_menu_hover: '',
            rightside_link: 'd40202',
            common_links: 'd40202',
            lat_title: 'd40202',
            lat_back: 'd40202',
            footer_cat_back: 'e70f0f',
            foot_back: 'd40202',
            free_title: 'd40202',
            featured_title: 'd40202',
            detail_titles: 'd40202'
        }]
    },
    // Domain ID 4 - Cronulla Classifieds
    4: {
        id: 4,
        url: 'www.cronullaclassifieds.com.au',
        title: 'Cronulla Classifieds',
        main_title: 'Cronulla Classifieds',
        zip_range: '2217,2218,2219,2224,2225,2226,2227,2228,2229,2230,2231,2232,2236,2238',
        domain_img: 'cronulla-logo.png',
        map: 'mapaus_crol.gif',
        dom_Onlineimg: '1000-black.png',
        dom_sidefreead: 'crnlcfd-postyourad.png',
        manage_ad: 'c-manage_ads.gif',
        dom_sidelogin: 'c-member_login.gif',
        domore: 'domorecor.png',
        fblogin: 'fb-logincor.png',
        fblogout: 'fb-log-out_cor.png',
        fb_app_id: '373851033064465',
        fb_secret: 'ac0de64d512d59913c7dc43843798322',
        searchedlistimg: 'serch-6.png',
        fevadsimg: 'serch-5.png',
        showDomainads: 0,
        domain_meta_title: 'Cronulla and Sydney\'s Sutherland Shire free classifieds',
        domain_meta_keywords: 'Cronulla Jobs, Cronulla Realestate, Cronulla restaurants, Tradies, Cronulla accommodation, Cronulla beach, Cronulla roommate, Cronulla flatmate, Cronulla business, Cronulla shopping, Cronulla nightlife, Cronulla business services, Sutherland shire news, Sutherland Shire classifieds',
        domain_meta_desc: 'Free Classifieds for Cronulla and Sutherland Shire Sydney - 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell , Escort services and more.',
        fbsharetitle: '',
        fbsharedescription: '',
        showlocalnews: 0,
        domain_webmaster: 'OsVc0O4Gnb0oH3wbafCIk1QgYqM2CQUMg5c-lvmCgkU',
        is_deleted: 1,
        styles: [{
            id: 2,
            domain_id: 4,
            time_color: '222222',
            header_search_text: '000000',
            header_buttoncolor: '222222',
            header_menu: '222222',
            header_menu_hover: '999999',
            side_text: '000000',
            side_back: '222222',
            list_side_back: 'e6e9ec',
            leftside_link: '000000',
            left_menu_hover: '999999',
            rightside_link: '',
            common_links: '022DAE',
            lat_title: '222222',
            lat_back: '',
            footer_cat_back: '999999',
            foot_back: '222222',
            free_title: '222222',
            featured_title: '222222',
            detail_titles: '222222'
        }]
    },
    // Domain ID 15 - Newtown Classifieds
    15: {
        id: 15,
        url: 'https://www.newtownclassifieds.com.au',
        title: 'Newtown Classifieds',
        main_title: 'Newtown Classifieds',
        zip_range: '2042,2046,2015,2038,2193,2043,2037,2045,2140,2127,2049,2138,2204,2009,2048,2007,2050,2044',
        domain_img: 'newtown-logo.png',
        map: 'mapausnew.gif',
        dom_Onlineimg: '1000-logoblue.png',
        dom_sidefreead: 'newtwon-postyourad.png',
        manage_ad: 'nt-manage_ads_1.gif',
        dom_sidelogin: 'nt-member_login_1.gif',
        domore: 'domorecor.png',
        fblogin: 'fb-loginnt12.png',
        fblogout: 'fb-log-out_new.png',
        fb_app_id: '540948906238514',
        fb_secret: '0e54076af618562a70c4d8a9afb27404',
        searchedlistimg: 'serch-15.png',
        fevadsimg: 'serch-16.png',
        showDomainads: 0,
        domain_meta_title: 'Newtown and Inner City Sydney free online classifieds ',
        domain_meta_keywords: 'Newtown Jobs, Newtown Realestate, Newtown restaurants, Tradies, Newtown accommodation, Newtown beach, Newtown roommate, Newtown flatmate, Newtown business, Newtown shopping, Newtown nightlife, Newtown business services, Newtown escorts, Inner City Sydney, Inner West Sydney, King street Newtown, Enmore, Erskineville, Dulwich Hill, Marrickville, Glebe, Chippendale',
        domain_meta_desc: 'Free Classifieds for Newtown and Inner City Sydney - 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more .',
        fbsharetitle: 'Newtown and Inner City Sydney free online classifieds ',
        fbsharedescription: 'Free online Classifieds for Newtown and inner city Sydney - 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more .',
        showlocalnews: 0,
        domain_webmaster: 'VBGJ733fdfWohpTkmbEq14pA07YesPiunkd4FrUgWyM',
        is_deleted: 0,
        styles: [{
            id: 3,
            domain_id: 15,
            time_color: '001D97',
            header_search_text: '000000',
            header_buttoncolor: '001D97',
            header_menu: '001D97',
            header_menu_hover: '485cae',
            side_text: '',
            side_back: '001D97',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '8C94B5',
            rightside_link: 'fff',
            common_links: '001D97',
            lat_title: '001D97',
            lat_back: '001D97',
            footer_cat_back: '8C94B5',
            foot_back: '001D97',
            free_title: '001D97',
            featured_title: '001D97',
            detail_titles: '001D97'
        }]
    },
    // Domain ID 16 - Stkilda Classifieds
    16: {
        id: 16,
        url: 'www.stkildaclassifieds.com.au',
        title: 'Stkilda Classifieds',
        main_title: 'Stkilda Classifieds',
        zip_range: '3000,3032,3207,3051,3003,3141,3053,3005,3006,3054,3052,3004,3002,3008,3000,3031,3031,3050,3010,3002,3207,3006,3182,3181,3144,3145,3737,3714,3962,3206,3871,3305,3078,3249,3221,3898,3233,3319,3631,3723,3480,3551,3147,3049,3664,3559,3067,3984,3393,3042,3971,3350,3691,3465,3018,3371,3715,3230,3579,3377,3995,3523,3551,3467,3782,3040,3352,3237,3424,3823,3277,3727,3825,3995,3549,3475,3022,3143,3099,3442,3570,3478,3551,3825,3465,3021,3020,3364,3979,3468,3393,3414,3951,3629,3377,3147,3818,3212,3034,3551,3201,3122,3223,3138,3166,3134,3132,3205,3174,3043,3175,3183,3065',
        domain_img: 'stkildaclassifieds.png',
        map: 'mapaus_stkilda.gif',
        dom_Onlineimg: '1000-black.png',
        dom_sidefreead: 'manlycfd-postyourad.png',
        manage_ad: 'manage-adssc1.gif',
        dom_sidelogin: 'member-login-buttonstkilda.gif',
        domore: 'domorecor.png',
        fblogin: 'fblog1.png',
        fblogout: 'fb-logoutstkilda.png',
        fb_app_id: '135712147194158',
        fb_secret: '3fe5bc22d0a8aa9b7af371524c59d0f2',
        searchedlistimg: 'searchhis.png',
        fevadsimg: 'fevads.png',
        showDomainads: 0,
        domain_meta_title: 'St Kilda Melbourne online classifieds',
        domain_meta_keywords: 'Melbourne Classifieds, Melbourne jobs, Melbourne Realestate, Melbourne business services , Stkilda Jobs, Stkilda realestate, Stkilda restaurants, Stkilda tradies, Stkilda accommodation, Stkilda beach, Stkilda roommate, Stkilda flatmate, Stkilda business, Stkilda shopping, Stkilda nightlife, Stkilda business services, Melbourne AD\'s ,Melbourne, Melbourne City',
        domain_meta_desc: 'Free Classifieds for StKilda and Melbourne City VIC - 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, adult services and more .',
        fbsharetitle: 'St Kilda Melbourne free online classifieds',
        fbsharedescription: 'Free online classifieds for StKilda and Melbourne City- 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, adult services and more .',
        showlocalnews: 1,
        domain_webmaster: '8AbPsLEG892WqCiaB-_nxuaKDdy5oWrm-mklOuqcD8A',
        is_deleted: 1,
        styles: [{
            id: 4,
            domain_id: 16,
            time_color: '091119',
            header_search_text: '000000',
            header_buttoncolor: '091119',
            header_menu: '091119',
            header_menu_hover: 'cd0000',
            side_text: '0D58A7',
            side_back: '091119',
            list_side_back: 'E6E9EC',
            leftside_link: '091119',
            left_menu_hover: 'c1d5ea',
            rightside_link: '',
            common_links: '361619',
            lat_title: '091119',
            lat_back: '',
            footer_cat_back: '4A4A4A',
            foot_back: '091119',
            free_title: '091119',
            featured_title: '091119',
            detail_titles: '091119'
        }]
    },
    // Domain ID 17 - Gosford Classifieds
    17: {
        id: 17,
        url: 'www.gosfordclassifieds.com.au',
        title: 'Gosford and Central Coast NSW Classifieds',
        main_title: 'Gosford Classifieds',
        zip_range: '2250,2251,2260,2252,2253,2254,2255,2256,2257,2258,2259,2260.2261,2262,2263,2264,2265,2266,2267,2268,2269,2270,2271,2272,2273,2274,2275,2276,2277,2278,2279,2280,2281,2282,2283,2284,2285,2286,2287,2288,2289,2290,2291,2292,2293,2294,2295,2296,2297,2298,2299,2300,2301,2302,2303,2304,2305,2306,2307,2308,2309,2310,2311,2312,2313,2314,2315,2316,2317,2318,2319,2320,2321,2322,2323,2324,2325,2326,2327,2328,2329,2330,2331,2332,2333,2334,2335,2336,2337,2338,2339,2340,2341,2342,2343,2344,2345,2346,2347,2348,2349,2350,2351,2352,2353,2354,2355,2356,2357,2358,2359,2360,2361,2362,2363,2364,2365,2366,2367,2368,2369,2370,2371,2372,2373,2374,2375,2376,2377,2378,2379,2380,2381,2382,2383,2384,2385,2386,2387,2388,2389,2390,2391,2392,2393,2394,2395,2396,2397,2398,2399,2400,2401,2402,2403,2404,2405,2406,2407,2408,2409,2410,2411,2412,2413,2414,2415,2416,2417,2418,2419,2420,2428',
        domain_img: 'gosford.png',
        map: 'mapaus_crolg.gif',
        dom_Onlineimg: '1000-logo-b2.png',
        dom_sidefreead: 'stg-postyourad.png',
        manage_ad: 'manage-adsg.gif',
        dom_sidelogin: 'member-login-buttongosford.gif',
        domore: 'domorecor.png',
        fblogin: 'fblog2.png',
        fblogout: 'fb-logoutgosford.png',
        fb_app_id: '558913997773800',
        fb_secret: '48e8264b578d82ae1065444f00ef45e3',
        searchedlistimg: 'searchhis.png',
        fevadsimg: 'fevads.png',
        showDomainads: 0,
        domain_meta_title: 'Gosford Central Coast NSW free classifieds',
        domain_meta_keywords: 'Gosford Jobs, Central Coast Realestate, Gosford restaurants, Gosford tradies, Central Coast accommodation, Gosford beachs, Gosford roommate, Gosford flatmate, Gosford business, Gosford shopping, Gosford nightlife, Gosford business services, Gosford realestate, Gosford holiday, Gosford escorts, Central Coast news, Central Coast council, Central Coast, Terrigal, Avoca, Woy Woy, Umina, The Entrance',
        domain_meta_desc: 'Free Classifieds for Gosford Central Coast NSW- 1,000\'s of AD\'s near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more .',
        fbsharetitle: 'Gosford and Central Coast NSW free online classifieds',
        fbsharedescription: 'Free online Classifieds for Gosford and Central Coast NSW- 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more .',
        showlocalnews: 0,
        domain_webmaster: 'CP6TI-mINQGaIhqSEELqrKqDOtn_nxsMqisVflq79-8',
        is_deleted: 1,
        styles: [{
            id: 5,
            domain_id: 17,
            time_color: '1D207E',
            header_search_text: '000000',
            header_buttoncolor: '1D207E',
            header_menu: '1D207E',
            header_menu_hover: 'cd0000',
            side_text: '',
            side_back: '1D207E',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '8C94B5',
            rightside_link: '',
            common_links: '',
            lat_title: '1D207E',
            lat_back: '1D207E',
            footer_cat_back: '393DBA',
            foot_back: '1D207E',
            free_title: '',
            featured_title: '',
            detail_titles: ''
        }]
    },
    // Domain ID 18 - Wollongong Classifieds
    18: {
        id: 18,
        url: 'www.wollongongclassifieds.com.au',
        title: 'Wollongong Classifieds',
        main_title: 'Wollongong Classifieds',
        zip_range: '2500,2529,2540,2533,2515,2527,2516,2530,2519,2528,2577,2518,2506,2577,2508,2526,2502,2519,2526,2525,2534,2577,2505,2528,2519,2515,2518,2534,2517,2530,2234',
        domain_img: 'wollongongclassifieds.png',
        map: 'mapauswollongong.gif',
        dom_Onlineimg: '1000-dark-blue.png',
        dom_sidefreead: 'stg-postyourad.png',
        manage_ad: 'manage-adswc.gif',
        dom_sidelogin: 'member-login-buttonwollongong.gif',
        domore: 'domorecor.png',
        fblogin: 'fblog3.png',
        fblogout: 'fb-logoutwollongong.png',
        fb_app_id: '1796207000677260',
        fb_secret: '4304e52ce71df616e956eb2d50407729',
        searchedlistimg: 'searchhis.png',
        fevadsimg: 'fevads.png',
        showDomainads: 0,
        domain_meta_title: 'Wollongong NSW South Coast online classifieds',
        domain_meta_keywords: 'Wollongong Jobs, Wollongong Realestate, Wollongong  tradies, Wollongong accommodation, Wollongong beach, Wollongong roommate, Wollongong flatmate,  Wollongong business,  Wollongong shopping, Wollongong nightlife, Wollongong business services, Wollongong news, South Coast NSW',
        domain_meta_desc: 'Free Classifieds Wollongong NSW South Coast - 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more .',
        fbsharetitle: 'Wollongong and NSW South Coast free online classifieds',
        fbsharedescription: 'Free online Classifieds for Wollongong and NSW South Coast - 1,000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Buy & Sell, Escort services and more .',
        showlocalnews: 0,
        domain_webmaster: 'h_W_5ToWfK2mDBrYWC1uspCFxDsv5UVHF-n_IfFbiU0',
        is_deleted: 1,
        styles: [{
            id: 6,
            domain_id: 18,
            time_color: '2C3B80',
            header_search_text: '',
            header_buttoncolor: '2C3B80',
            header_menu: '2C3B80',
            header_menu_hover: 'cd0000',
            side_text: '',
            side_back: '2C3B80',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '8C94B5',
            rightside_link: '2C3B80',
            common_links: '2C3B80',
            lat_title: '',
            lat_back: '5463A5',
            footer_cat_back: '2C3B80',
            foot_back: '2C3B80',
            free_title: '2C3B80',
            featured_title: '2C3B80',
            detail_titles: '2C3B80'
        }]
    },
    // Domain ID 19 - Metro Classifieds
    19: {
        id: 19,
        url: 'www.metroclassifieds.com.au',
        title: 'Australia Free Classifieds - MetroClassifieds.com.au',
        main_title: 'Metro Classifieds',
        zip_range: '3000,4000,5000,6000,7000,0800,3199',
        domain_img: 'metroclassifieds.png',
        map: 'nt-mapaus.gif',
        dom_Onlineimg: 'online-adsmetro.png',
        dom_sidefreead: 'free-ad-buttonmetro.gif',
        manage_ad: 'manage-adsmetro.gif',
        dom_sidelogin: 'member-login-buttonmetro.gif',
        domore: 'domorecor.png',
        fblogin: 'fb-loginmetro1.png',
        fblogout: 'fb-logoutmetro.png',
        fb_app_id: '',
        fb_secret: '',
        searchedlistimg: 'searchhis.png',
        fevadsimg: 'fevads.png',
        showDomainads: 1,
        domain_meta_title: 'Australia Free Classifieds - MetroClassifieds.com.au',
        domain_meta_keywords: 'Australia Jobs, australian realestate, australian restaurants, australian tradies, australia accommodation, australian beachs, australian roommates, australia education, australian business, australian shopping, australian nightlife, australia business services, Online Classified Ads in your area, Free Local Classified Ads, Find Classifieds, Free Local Advertising, Post Free Classified Ads, Post Free Ads Online for your Business, Search For Free Ads Sydney, Free Ads Brisbane, Free Ads Australia Wide, Free Advertisement for Your Business in our Business Directory Section, Post Free Online Ads for Business events, Sale and Special offers, Local Classifieds Personals , sydney classifieds, melbourne classifieds, perth classifieds, brisbane classifieds, adelaide classifieds, darwin classifieds, tasmania classifieds, hobart classifieds, cairns classifieds, canberra classifieds, country classifieds, regional classifieds',
        domain_meta_desc: 'Australia free classifieds for Sydney, Melbourne, Brisbane, Adelaide, Perth, Darwin and Hobart- 1,000\'s of ads near you for Jobs, Realestate, Business services, Cars, Buy & Sell, Personals , Escort services',
        fbsharetitle: 'Australia wide free online classifieds for Sydney, Melbourne, Brisbane, Adelaide, Perth, Darwin & Ho',
        fbsharedescription: 'Australia wide free classifieds including Sydney, Melbourne, Brisbane, Adelaide, Perth, Darwin and Hobart- 1,000\'s of ads near you for Jobs, Realestate, Business services, Cars, Buy & Sell, Personals , Escort services',
        showlocalnews: 0,
        domain_webmaster: '',
        is_deleted: 1,
        styles: [{
            id: 7,
            domain_id: 19,
            time_color: '2C3B80',
            header_search_text: '000000',
            header_buttoncolor: '2C3B80',
            header_menu: '2C3B80',
            header_menu_hover: 'cd0000',
            side_text: '',
            side_back: '2C3B80',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '8C94B5',
            rightside_link: '',
            common_links: '',
            lat_title: '2C3B80',
            lat_back: '2C3B80',
            footer_cat_back: '5463A5',
            foot_back: '2C3B80',
            free_title: '2C3B80',
            featured_title: '2C3B80',
            detail_titles: '2C3B80'
        }]
    },
    // Domain ID 20 - South Sydney Classifieds
    20: {
        id: 20,
        url: 'https://www.southsydneyclassifieds.com.au',
        title: 'South Sydney Classifieds',
        main_title: 'South Sydney Classifieds',
        zip_range: '2018,2020,2007,2008,2009,2010,2011,2015,2016,2018,2019,2017',
        domain_img: 'domains_1729522986752_southsydneyclassifieds.png',
        map: 'southsydneyaus_map.gif',
        dom_Onlineimg: 'domains_1732523836176_1000-dark-redman.png',
        dom_sidefreead: 'domains_1732521089860_ssc-post-your-ad.png',
        manage_ad: 'domains_1732523654884_domains_1732521089856_ssc-mange-ad.png',
        dom_sidelogin: 'domains_1732523779376_domains_1732520537803_ssc-member-login.png',
        domore: 'domains_1732520626235_domorecor.png',
        fblogin: 'domains_1732523779377_domains_1732520668544_ssc-log-in-with-facebook.png',
        fblogout: 'domains_1732523779378_domains_1732521205882_ssc-log-out-with-facebook.png',
        fb_app_id: '419794912926314',
        fb_secret: '5d4a2804d5e4dc09fd3286931ebbf745',
        searchedlistimg: 'domains_1732523779377_domains_1732521089856_ssc-search-history.png',
        fevadsimg: 'domains_1732521089855_ssc-favorite-ads.png',
        showDomainads: 0,
        domain_meta_title: 'South Sydney Online Classifieds',
        domain_meta_keywords: 'South Sydney Jobs, South Sydney realestate, South Sydney restaurants, tradies,  South Sydney accommodation, South Sydney beach, South Sydney roommate, South Sydney flatmate, South Sydney business, South Sydney shopping, South Sydney nightlife, South Sydney news, free classifieds, Sydney Escorts, Sydney Massage, South Sydney Escorts, South Sydney Massage, adult ads, erotic services',
        domain_meta_desc: 'Online Classifieds for South Sydney NSW - 1000\'s of ads for Business services, Jobs, Realestate, Personals, Buy & Sell, Cars, Market Place, Adult services and more',
        fbsharetitle: '',
        fbsharedescription: '',
        showlocalnews: 0,
        domain_webmaster: 'o-kmIbFKxuVPVLFx_th1yJELUVHR8Kzz2ahn5TWTlxc',
        is_deleted: 0,
        styles: [{
            id: 8,
            domain_id: 20,
            time_color: '9A0000',
            header_search_text: '',
            header_buttoncolor: '9A0000',
            header_menu: '9A0000',
            header_menu_hover: '1f7103',
            side_text: '',
            side_back: '9A0000',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '8C94B5',
            rightside_link: '',
            common_links: '',
            lat_title: '9A0000',
            lat_back: '9A0000',
            footer_cat_back: 'AB6363',
            foot_back: '9A0000',
            free_title: '9A0000',
            featured_title: '9A0000',
            detail_titles: '9A0000'
        }]
    },
    // Domain ID 21 - StGeorge Classifieds
    21: {
        id: 21,
        url: 'https://www.stgeorgeclassifieds.com.au',
        title: 'StGeorge Classifieds',
        main_title: 'StGeorge Classifieds',
        zip_range: '2172,2205,2207,2208,2209,2210,2216,2217,2218,2219,2220,2221,2222,2223,2224,2225,2226,2227,2228,2229,2230,2231,2232,2233,2234',
        domain_img: 'domains_1729523186862_stgeorgeclassifieds.png',
        map: 'mapaus_stgeorge.gif',
        dom_Onlineimg: 'domains_1732521419616_1000-black.png',
        dom_sidefreead: 'domains_1732521419617_st-postad.png',
        manage_ad: 'domains_1732521419633_st-manage-ads.png',
        dom_sidelogin: 'domains_1732521419667_st-member-login.png',
        domore: 'domains_1732521419667_domorecor.png',
        fblogin: 'domains_1732521419668_st-fb-login.png',
        fblogout: 'domains_1732521419690_st-fb-logout.png',
        fb_app_id: '648861296103676',
        fb_secret: '8a36b05d04bb9a308caa4d817044c7c5',
        searchedlistimg: 'domains_1732521419667_st-search.png',
        fevadsimg: 'domains_1732521419667_st-favrits.png',
        showDomainads: 0,
        domain_meta_title: 'Online Classifieds for St George and Sutherland Shire Sydney',
        domain_meta_keywords: 'StGeorge Jobs, StGeorge Realestate, StGeorge restaurants, StGeorge tradies, StGeorge accommodation, StGeorge beach, StGeorge roommate, StGeorge flatmate, StGeorge business , StGeorge shopping, StGeorge nightlife, StGeorge business services, StGeorge news, Rockdale council, Kogarah, Brighton Le sands, Rockdale, Bexley, Ramsgate, San Souci, Dolls Point,',
        domain_meta_desc: 'Classifieds for St George and Sutherland Shire Sydney- 1,000\'s of ads near you for Jobs, Realestate, Cars, Business services, Market Place, Adult Services, Personals and more .',
        fbsharetitle: 'St George Sydney NSW free online classifieds',
        fbsharedescription: 'Online Classifieds for Sydney\'s St George and Sutherland Shire region- 1,000\'s of ads near you for jobs, housing, business services, personals, cars, adult services and more .',
        showlocalnews: 0,
        domain_webmaster: 'I2LmUCSVz8-LYkp9W0wc28mMMnHJW-WsoEJLMfMGOHk',
        is_deleted: 0,
        styles: [{
            id: 9,
            domain_id: 21,
            time_color: '100E0E',
            header_search_text: '000000',
            header_buttoncolor: '100E0E',
            header_menu: '100E0E',
            header_menu_hover: 'cd0000',
            side_text: '',
            side_back: '100E0E',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '8C94B5',
            rightside_link: '100E0E',
            common_links: '100E0E',
            lat_title: '100E0E',
            lat_back: '100E0E',
            footer_cat_back: '625F5F',
            foot_back: '100E0E',
            free_title: '100E0E',
            featured_title: '100E0E',
            detail_titles: '100E0E'
        }]
    },
    // Domain ID 22 - North Sydney Classifieds
    22: {
        id: 22,
        url: 'https://www.northsydneyclassifieds.com.au',
        title: 'North Sydney Classifieds',
        main_title: 'North Sydney Classifieds',
        zip_range: '2064,2121,2055,2059,2060,2057,2057,1515,2066,2113,2114,2112,2111,2062,2068,2067,2090,2065,2110,2061,2089,2066,2088,2063,2069,2070,2071,2072,2073,2074,2075,2076,2077,2079,2080,2081,2082,2083,2117,2118,21192120,2121,2122,2125,2126,2151,2152,2153,2154,2155,2156,2157,2158,2159,2756,2765,2775',
        domain_img: 'domains_1729523234347_nslogo.png',
        map: 'northsydneyaus_map.gif',
        dom_Onlineimg: 'domains_1732521596458_1000-maroon.png',
        dom_sidefreead: 'domains_1732521596458_post-your-ad.png',
        manage_ad: 'domains_1732521596459_ns-mange-ad.png',
        dom_sidelogin: 'domains_1732521596496_ns-log-in-with-facebook.png',
        domore: '',
        fblogin: 'domains_1732521596497_ns-log-in-with-facebook.png',
        fblogout: 'domains_1732521596497_ns-log-out-with-facebook.png',
        fb_app_id: '369061005013399',
        fb_secret: '03534cc17bba254f8ed2c67a34c2b384',
        searchedlistimg: 'domains_1732521596497_search-history.png',
        fevadsimg: 'domains_1732521596497_ns-favorite-ads.png',
        showDomainads: 0,
        domain_meta_title: 'North Sydney Online Classifieds',
        domain_meta_keywords: 'North Sydney Jobs, North Sydney realestate, North Sydney restaurants, tradies,  North Sydney accommodation, North Sydney beach, North Sydney roommate, North Sydney flatmate, North Sydney business, North Sydney shopping, North Sydney nightlife, North Sydney news, free classifieds, North Sydney council, North Sydney business services',
        domain_meta_desc: 'Classifieds for North Sydney - 1000\'s of ads for Business Services, Jobs, Realestate, Personals, Buy & Sell, Cars, Adult services and more',
        fbsharetitle: 'North Sydney Online Classifieds',
        fbsharedescription: 'Online Classifieds for North Sydney - 1000\'s of ads near you for Jobs, Realestate, Business services, personals, Cars, Buy & sell , Adult services and more',
        showlocalnews: 0,
        domain_webmaster: '0ugax7WLTJ7X23n8_N_1q5Ls2S3pLOoKZL3qYtl89e8',
        is_deleted: 0,
        styles: [{
            id: 11,
            domain_id: 22,
            time_color: 'B00A30',
            header_search_text: '000000',
            header_buttoncolor: 'B00A30',
            header_menu: 'B00A30',
            header_menu_hover: '213071',
            side_text: 'B00A30',
            side_back: 'B00A30',
            list_side_back: 'e6e9ec',
            leftside_link: '213071',
            left_menu_hover: '213071',
            rightside_link: 'B00A30',
            common_links: 'B00A30',
            lat_title: 'B00A30',
            lat_back: '',
            footer_cat_back: 'E59AAA',
            foot_back: 'B00A30',
            free_title: 'B00A30',
            featured_title: 'B00A30',
            detail_titles: 'B00A30'
        }]
    },
    // Domain ID 23 - Queensland Classifieds
    23: {
        id: 23,
        url: 'www.queenslandclassifieds.com.au',
        title: 'Queensland Classifieds',
        main_title: 'Queensland Classifieds',
        zip_range: '4000,4001,4002,4003,4004,4005,4006,4007,4008,4009,4010,4011,4012,4013,4014,4017,4018,4019,4020,4021,4022,4025,4029,4030,4031,4032,4034,4035,4036,4037,4051,4053,4054,4055,4059,4060,4061,4064,4065,4066,4067,4068,4069,4070,4073,4074,4075,4076,4077,4078,4100,4101,4102,4103,4104,4105,4106,4107,4108,4109,4110,4111,4112,4113,4114,4115,4116,4117,4118,4119,4120,4121,4122,4123,4124,4127,4128,4129,4130,4131,4132,4133,4150,4151,4152,4153,4154,4155,4156,4157,4158,4159,4160,4161,4163,4164,4165,4207,4211,4217,4558,4300',
        domain_img: 'domains_1732258121523_qc-logo.png',
        map: 'qcausmap.gif',
        dom_Onlineimg: 'domains_1732521868926_1000-dark-redman.png',
        dom_sidefreead: 'domains_1732521868926_qc-postad.png',
        manage_ad: 'domains_1732521868926_qc-manage-ads.png',
        dom_sidelogin: 'domains_1732521868977_qc-fb-login.png',
        domore: 'domains_1732521868978_do-more.png',
        fblogin: 'domains_1732521868978_qc-fb-login.png',
        fblogout: 'domains_1732521868979_qc-fb-logout.png',
        fb_app_id: '264723348939786',
        fb_secret: '631bd9b56216eaa659d1d365ea3ff64f',
        searchedlistimg: 'domains_1732521868978_qc-search.png',
        fevadsimg: 'domains_1732521868978_qc-favrits.png',
        showDomainads: 0,
        domain_meta_title: 'Queensland Free  Classifieds',
        domain_meta_keywords: 'Queensland  Jobs, Queensland  realestate, Queensland  restaurants, tradies,  Queensland   accommodation, Queensland  beach, Queensland  roommate, Queensland  flatmate, Queensland  business, Queensland  shopping, Queensland  nightlife, Queensland  news, free classifieds, QLD Classifieds, gold coast classifieds, business services, qld escorts, Brisbane Classifieds , Gold Coast Classifieds',
        domain_meta_desc: 'Free online Classifieds for Queensland Australia - 1000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Escort services and more',
        fbsharetitle: 'Queensland Australia Free Online Classifieds',
        fbsharedescription: 'Free online Classifieds for Queensland Australia - 1000\'s of ads near you for Jobs, Realestate, Business services, Personals, Cars, Escort services and more',
        showlocalnews: 1,
        domain_webmaster: 'PH-A7BFrflSmyNhFV7BCTDTTLhFtDE2i2gDNgqG3OZo',
        is_deleted: 0,
        styles: [{
            id: 10,
            domain_id: 23,
            time_color: '9A0000',
            header_search_text: '9A0000',
            header_buttoncolor: '9A0000',
            header_menu: '9A0000',
            header_menu_hover: '091119',
            side_text: '9A0000',
            side_back: '9A0000',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '',
            rightside_link: '9A0000',
            common_links: '9A0000',
            lat_title: '9A0000',
            lat_back: '',
            footer_cat_back: 'AB6363',
            foot_back: '9A0000',
            free_title: '9A0000',
            featured_title: '9A0000',
            detail_titles: '9A0000'
        }]
    },
    // Domain ID 24 - West Sydney Classifieds
    24: {
        id: 24,
        url: 'https://www.westsydneyclassifieds.com.au',
        title: 'West Sydney Classifieds',
        main_title: 'West Sydney Classifieds',
        zip_range: '2150,2049,2170,2168,2038,2039,2040,2041,2176,2763,2148,2555,2155,2153,2765,2770,2177,2556,2747,2749,2171,2178,2761,2760,2749,2767,2766,2750,2759,2145,2175,2147,2340,2148,2550,2748,2762,2752,2330,2769,2146,2164,2115,2116,2117,2118,2121,2122,2127,2128,2140,2141,2142,2143,2144,2145,2146,2148,2150,2151,2152,2153,2160,2161,2162,2164,2045,2046,2047,2130,2131,2132,2133,2134,2135,2136,2137,2138,2140,2190,2191,2193,2167,2174,2179,2557,2558,2559,2560,2563,2564,2565,2566,2567,2568,2569,2570,2571,2572,2573,2574,2745,2752,2787,2133,2143,2161,2162,2163,2190,2191,2192,2193,2194,2195,2196,2197,2198,2199,2200,2206,2208,2209,2210,2211,2212,2213,2214',
        domain_img: 'domains_1729523036114_westsydneyclassifieds_web.png',
        map: 'wsaus_stgeorge.gif',
        dom_Onlineimg: 'domains_1732521736063_1000-orange.png',
        dom_sidefreead: 'domains_1732521736063_ws-post-your-ad.png',
        manage_ad: 'domains_1732521736064_ws-mange-ad.png',
        dom_sidelogin: 'domains_1732521736090_ws-log-in-with-facebook.png',
        domore: '',
        fblogin: 'domains_1732521736091_ws-log-in-with-facebook.png',
        fblogout: 'domains_1732521736094_ws-log-out-with-facebook.png',
        fb_app_id: '213124670936857',
        fb_secret: 'f66b9915911f0dff99e9453ade6a10c1',
        searchedlistimg: 'domains_1732521736091_ws-search-history.png',
        fevadsimg: 'domains_1732521736091_ws-favorite-ads.png',
        showDomainads: 0,
        domain_meta_title: 'West Sydney Classifieds',
        domain_meta_keywords: 'West Sydney Jobs, West Sydney realestate, West Sydney restaurants, tradies,  West Sydney accommodation, West Sydney beach, West Sydney roommate, West Sydney flatmate, West Sydney business, West Sydney shopping, West Sydney nightlife, West Sydney news, free classifieds',
        domain_meta_desc: 'Online Classifieds for Western Sydney - 1000\'s of ads for Business Services, Jobs, Realestate, Personals, Buy & Sell, Cars, Market Place, Adult services and more',
        fbsharetitle: 'West Sydney Free Online Classifieds',
        fbsharedescription: 'Online Classifieds for West Sydney - 1000\'s of ads near you for Business services, Jobs, Realestate, Personals, Buy & Sell, Cars, Adult  services and more',
        showlocalnews: 0,
        domain_webmaster: 'FIbxn8KZ1AWO_5CXskBPUXr9CJriSRo4aOLSCWEHv6Q',
        is_deleted: 0,
        styles: [{
            id: 12,
            domain_id: 24,
            time_color: 'FF8500',
            header_search_text: '000000',
            header_buttoncolor: 'FF8500',
            header_menu: 'FF8500',
            header_menu_hover: '000000',
            side_text: 'FF8500',
            side_back: 'FF8500',
            list_side_back: 'e6e9ec',
            leftside_link: '',
            left_menu_hover: '000000',
            rightside_link: 'FF8500',
            common_links: 'FB0025',
            lat_title: 'FF8500',
            lat_back: '',
            footer_cat_back: 'EFA85A',
            foot_back: 'FF8500',
            free_title: 'FF8500',
            featured_title: 'FF8500',
            detail_titles: 'FF8500'
        }]
    },
    // Domain ID 25 - Tasmania Classifieds
    25: {
        id: 25,
        url: 'www.tasmaniaclassifieds.com.au',
        title: 'Tasmania Classifieds',
        main_title: 'Tasmania Classifieds',
        zip_range: '7000,7001,7002,7004,7005,7006,7007,7008,7009,7010,7011,7012,7013,7014,7015,7016,7017,7018,7019,7020.7021,7021,7022,7023,7024,7025,7026,7027,7028,7029,7030,7050,7051,7052,7053,7054,7055,7109,7112,7113,7116,7117,7119,7120,7139,7140,7150,7151,7155,7162,7163,7170,7172,7173,7174,7175,7176,7177,7178,7179,7180,7181,7182,7183,7184,7185,7186,7187,7190,7209.7210,7211,7212,7213,7214,7215,7216,7248,7249,7250,7251,7252,7253,7254,7255,7256,7257,7258,7259,7260,7261,7262,7263,7264,7265,7266,7267,7268,7270,7275,7276,7277,7290,7291,7292,7300,7301,7302,7303,7304,7305,7306,7307,7310,7315,7316,7320,7321,7322,7325,7330,7331,7466,7467,7468,7469,7470,7800,7802,7803,7804,7805,7806,7807,7808,7809,7810,7811,7812,7813,7814,7823,7824,7827,7828,7829,7845,7850,7901,7902,7903,7904,7905,7906,7907,7908,7909,7910,7911,7912,7913,7914,7915,7916,7917,7918,7919,7920,7921,7922,7923',
        domain_img: 'logotasmania.png',
        map: 'caus_mapwestern.gif',
        dom_Onlineimg: '1000-green.png',
        dom_sidefreead: 'manlycfd-postyourad.png',
        manage_ad: 'qcmanageadswestern.gif',
        dom_sidelogin: 'member-login-buttontasmania.gif',
        domore: '',
        fblogin: 'fb-logintasmania.png',
        fblogout: 'fb-qclogoutwestern.png',
        fb_app_id: '288096075034986',
        fb_secret: '8f7512d79035989494aa3ee9d7974e60',
        searchedlistimg: 'serch-4.png',
        fevadsimg: 'serch-3.png',
        showDomainads: 0,
        domain_meta_title: 'Tasmania Free Classifieds',
        domain_meta_keywords: 'Tasmania  Jobs, Tasmania  realestate, Tasmania  restaurants, tradies,  Tasmania  accommodation, Tasmania  beach, Tasmania  roommate, Tasmania  flatmate, Tasmania  business, Tasmania  shopping, Tasmania  nightlife, Tasmania  news, free classifieds, Hobart Classifieds , Launceston Classifieds',
        domain_meta_desc: 'Free Classifieds for Tasmania- 1000\'s of ads for Business services, Jobs, Realestate, Personals, Buy & Sell, Cars, Escort services and more',
        fbsharetitle: 'Tasmania Australia Free Online Classifieds',
        fbsharedescription: 'Free online Classifieds for Tasmania  Australia - 1000\'s of ads near you for jobs, housing, business services, personals, cars, adult services and more',
        showlocalnews: 1,
        domain_webmaster: '9seAerdpzlb8pJUDPQc7yLLrkksZs8pQ73L1MTxKz-o',
        is_deleted: 1,
        styles: [{
            id: 14,
            domain_id: 25,
            time_color: '248303 ',
            header_search_text: '248303 ',
            header_buttoncolor: '248303 ',
            header_menu: '248303 ',
            header_menu_hover: 'c40000',
            side_text: '248303 ',
            side_back: '248303 ',
            list_side_back: '',
            leftside_link: '',
            left_menu_hover: 'c40000',
            rightside_link: '248303 ',
            common_links: 'c40000',
            lat_title: '248303 ',
            lat_back: '248303 ',
            footer_cat_back: '5c956b ',
            foot_back: '248303 ',
            free_title: '248303 ',
            featured_title: '248303 ',
            detail_titles: '248303 '
        }]
    },
    // Domain ID 26 - Darwin Classifieds
    26: {
        id: 26,
        url: 'www.darwinclassifieds.com.au',
        title: 'Darwin Classifieds',
        main_title: 'Darwin Classifieds',
        zip_range: '820,822,815,800,801,820,841,822',
        domain_img: 'logodrv.png',
        map: 'caus_mapdrvn.gif',
        dom_Onlineimg: '1000-dark-blue.png',
        dom_sidefreead: 'manlycfd-postyourad.png',
        manage_ad: 'qcmanadr.gif',
        dom_sidelogin: 'member-login-buttondrvn.gif',
        domore: '',
        fblogin: 'fb-logindrvn.png',
        fblogout: 'fb-qdr.png',
        fb_app_id: '902728106544243',
        fb_secret: '8183eae02d8a67d4b143017d3f3dab42',
        searchedlistimg: 'serch-4.png',
        fevadsimg: 'serch-3.png',
        showDomainads: 0,
        domain_meta_title: 'Darwin Free Classifieds',
        domain_meta_keywords: 'Darwin Jobs, Darwin Realestate, Darwin  restaurants, tradies,  Darwin accommodation, Darwin beach, Darwin   roommate, Darwin flatmate, Darwin business, Darwin  shopping, Darwin nightlife, Darwin news, free classifieds',
        domain_meta_desc: 'Free Classifieds Darwin - 1000\'s of ads near you for jobs, housing, business services, personals, cars, adult services and more',
        fbsharetitle: 'Darwin Australia Free Online Classifieds',
        fbsharedescription: 'Free online Classifieds for Darwin Australia - 1000\'s of ads near you for jobs, housing, business services, personals, cars, adult services and more',
        showlocalnews: 1,
        domain_webmaster: 'X1_kiSLHYL5Eds2ojk-3P4Y51vpGRmITuXESjpITcbQ',
        is_deleted: 1,
        styles: [{
            id: 15,
            domain_id: 26,
            time_color: '25578C',
            header_search_text: '000000',
            header_buttoncolor: '25578C',
            header_menu: '25578C',
            header_menu_hover: '4b7faf',
            side_text: '25578C',
            side_back: '25578C',
            list_side_back: '',
            leftside_link: '',
            left_menu_hover: '',
            rightside_link: '25578C',
            common_links: '',
            lat_title: '25578C',
            lat_back: '',
            footer_cat_back: '90B3D6',
            foot_back: '25578C',
            free_title: '25578C',
            featured_title: '25578C',
            detail_titles: '25578C'
        }]
    },
    // Domain ID 27 - Uni Classifieds
    27: {
        id: 27,
        url: 'www.uniclassifieds.com.au',
        title: 'Uni Classifieds',
        main_title: 'Uni Classifieds',
        zip_range: '6000',
        domain_img: 'uni400x223.jpg',
        map: 'uniaus_map.gif',
        dom_Onlineimg: '1000-dark-redman.png',
        dom_sidefreead: 'uni-free-ad-button.gif',
        manage_ad: 'uni-manage_ads.gif',
        dom_sidelogin: 'uni-member-login-button.gif',
        domore: '',
        fblogin: 'fb-loginuni.png',
        fblogout: '',
        fb_app_id: '',
        fb_secret: '',
        searchedlistimg: 'serch-uni.png',
        fevadsimg: 'uniserch-fev.png',
        showDomainads: 0,
        domain_meta_title: 'Australia\'s Free online classifieds for University Students | uniclassifieds.com.au',
        domain_meta_keywords: 'uni Jobs, uni realestate, eastern suburbs, sydney Melbourne tradies, uni accommodation, uni beach, uni roommate, uni flatmate, uni business, uni shopping, uni news, free classifieds, Classifieds, Sydney Melbourne Classifieds, sydney ads, Sydney realestate, sydney flatmate, roommate, sydney Melbourne jobs, sydney Melbourne business services,sydney news',
        domain_meta_desc: 'Free Classifieds for University Students Australia Wide- 1000\'s of ads near you for Business Services, Jobs, Real Estate, Buy and Sell, Courses and much more',
        fbsharetitle: '',
        fbsharedescription: '',
        showlocalnews: 0,
        domain_webmaster: '',
        is_deleted: 1,
        styles: [{
            id: 16,
            domain_id: 27,
            time_color: '9A0000',
            header_search_text: '',
            header_buttoncolor: '9A0000',
            header_menu: '9A0000',
            header_menu_hover: '324592',
            side_text: '',
            side_back: '9A0000',
            list_side_back: 'e6e9ec',
            leftside_link: '0d3b63',
            left_menu_hover: '1f7103',
            rightside_link: '9A0000',
            common_links: '',
            lat_title: '9A0000',
            lat_back: '9A0000',
            footer_cat_back: 'AB6363',
            foot_back: '9A0000',
            free_title: '9A0000',
            featured_title: '9A0000',
            detail_titles: '9A0000'
        }]
    }
};

// Helper function to get domain data by ID
export const getDomainData = (domainId) => {
    return STATIC_DOMAIN_DATA[domainId] || STATIC_DOMAIN_DATA[0];
};

// Helper function to get domain styles by ID
export const getDomainStyles = (domainId) => {
    const domainData = getDomainData(domainId);
    return domainData.styles || [];
};

// Helper function to get domain content (for backward compatibility)
export const getDomainContent = (domainId) => {
    const domainData = getDomainData(domainId);
    // Return in the format expected by existing code
    return [domainData];
};

// Helper function to get current domain ID from hostname
export const getCurrentDomainId = () => {
    if (typeof window === 'undefined') return 0;
    const host = window?.location?.hostname || '';
    const DOMAIN_HOST_MAP = {
        'bondiclassifieds.com.au': 0,
        'www.bondiclassifieds.com.au': 0,
        'localhost': 0,
        '127.0.0.1': 0,
        'bondi.lyonsdemo.in': 0,
        'manlyclassifieds.com.au': 2,
        'www.manlyclassifieds.com.au': 2,
        'westernaustraliaclassifieds.com.au': 3,
        'www.westernaustraliaclassifieds.com.au': 3,
        'cronullaclassifieds.com.au': 4,
        'www.cronullaclassifieds.com.au': 4,
        'newtownclassifieds.com.au': 15,
        'www.newtownclassifieds.com.au': 15,
        'stkildaclassifieds.com.au': 16,
        'www.stkildaclassifieds.com.au': 16,
        'gosfordclassifieds.com.au': 17,
        'www.gosfordclassifieds.com.au': 17,
        'wollongongclassifieds.com.au': 18,
        'www.wollongongclassifieds.com.au': 18,
        'metroclassifieds.com.au': 19,
        'www.metroclassifieds.com.au': 19,
        'southsydneyclassifieds.com.au': 20,
        'www.southsydneyclassifieds.com.au': 20,
        'stgeorgeclassifieds.com.au': 21,
        'www.stgeorgeclassifieds.com.au': 21,
        'northsydneyclassifieds.com.au': 22,
        'www.northsydneyclassifieds.com.au': 22,
        'queenslandclassifieds.com.au': 23,
        'www.queenslandclassifieds.com.au': 23,
        'westsydneyclassifieds.com.au': 24,
        'www.westsydneyclassifieds.com.au': 24,
        'tasmaniaclassifieds.com.au': 25,
        'www.tasmaniaclassifieds.com.au': 25,
        'darwinclassifieds.com.au': 26,
        'www.darwinclassifieds.com.au': 26,
        'uniclassifieds.com.au': 27,
        'www.uniclassifieds.com.au': 27,
    };
    const sanitizedHost = host.toLowerCase();
    return Object.prototype.hasOwnProperty.call(DOMAIN_HOST_MAP, sanitizedHost)
        ? DOMAIN_HOST_MAP[sanitizedHost]
        : 0;
};

